var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nuxt-link',{attrs:{"to":_vm.urlComputed}},[_c('div',{staticClass:"gr-heading-small",class:[
      _vm.isActiveComputed || _vm.noActiveColor ? 'black--text' : 'grey--text' ]},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }